import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import PageLayout from '../../components/ui/PageLayout';
import { buttonClass } from '../../components/ui/Button';
import { Field, FieldRow } from '../../components/ui/Field';
import { Select } from '../../components/ui/Select';
import { Panel } from '../../components/ui/Panel';

const ConfigurEdit = () => {
  const history = useHistory();
  const [title, setTitle] = useState('');
  const [condition, setCondition] = useState('');
  const [maintenance, setMaintenance] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [substitution, setSubstitution] = useState('');
  const [notes, setNotes] = useState('');
  const [escs, setEscs] = useState('');

  const handleCancel = () => {
    history.goBack();
  };

  // eslint-disable-next-line no-unused-vars
  const handleMaintChange = (e) => {
    if (e.target.className.includes('maintenance')) {
      const newMaint = [...maintenance];
      newMaint[e.target.dataset.id] = e.target.value;
      setMaintenance(newMaint);
    } else {
      setMaintenance([e.target.value]);
    }
  };

  // eslint-disable-next-line no-unused-vars
  const addMaintenance = () => {
    setMaintenance((prev) => [...prev, '']);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Process form submission (e.g., update configuration)
    console.log({ title, condition, maintenance, substitution, notes });
  };

  return (
    <PageLayout kind="focus" className="pt-4">
<Panel level={3} title={`Configuration: ${title}`}>
    <form
      className="flex flex-col flex-wrap font-semibold"
      onSubmit={handleSubmit}
    >
      <div>
        <FieldRow label="Title:" htmlFor="title">
          <Field
            type="text"
            name="title"
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </FieldRow>
      </div>
      <div className="mt-4">
        <FieldRow label="GPS Unit:" htmlFor="condition">
          <Select
            label="GPS Unit"
            name="condition"
            value={condition || null}
            onChange={setCondition}
            placeholder="Choose here"
            required
            options={[
              { key: 'conf1', label: 'New GPS' },
              { key: 'conf2', label: 'Old GPS' },
            ]}
          />
        </FieldRow>
      </div>
      <div className="mt-4">
        <FieldRow label="ESCs:" htmlFor="configuration">
          <Select
            label="ESCs"
            name="configuration"
            value={escs || null}
            onChange={setEscs}
            placeholder="Choose here"
            required
            options={[
              { key: 'conf1', label: 'Aikon ESC' },
              { key: 'conf2', label: 'Other ESC' },
            ]}
          />
        </FieldRow>
      </div>
      <div className="mt-4">
        <FieldRow label="Notes:" htmlFor="notes">
          <Field
            type="text"
            name="notes"
            onChange={(e) => setNotes(e.target.value)}
          />
        </FieldRow>
      </div>
      <button
        type="submit"
        className={`${buttonClass('filled')} my-[10px] w-full`}
      >
        Save
      </button>
      <button
        type="button"
        onClick={handleCancel}
        className={`${buttonClass('tonal')} my-[10px] w-full`}
      >
        Cancel
      </button>
    </form>
    </Panel>
</PageLayout>
  );
};

export default ConfigurEdit;
